<template>
    <div class="container card m-2 p-2">
        <div class="row">
            <div class="col-sm">
                <label for="nev">Beosztás</label>
            </div>
            <div class="col-sm" v-if="munkahely.felsooktatas">
                <label for="nev">Felsőoktatási intézmény</label>
            </div>
            <div class="col-sm" v-if="munkahely.felsooktatas">
                <label for="nev">Felsőoktatási kar</label>
                <button class="x-icon-delete" @click.prevent="deleteMunkahely" title="Munkahely törlése"></button>
            </div>
            <div class="col-sm-8" v-if="!munkahely.felsooktatas">
                <label for="nev">Munkahely neve</label>
                <button class="x-icon-delete" @click.prevent="deleteMunkahely" title="Munkahely törlése"></button>
            </div>
        </div>
        <div class="row">
            <div class="col-sm">
                <input type="text" id='nev' v-model.trim="munkahely.beosztas" class="form-control" title="Beosztása" required>
            </div>
            <div class="col-sm" v-if="munkahely.felsooktatas">
                <select v-model="munkahely.intezmenyKod" class="form-control" title="Felsőoktatási intézmény kódja" required>
                    <option value=""></option>
                    <option v-for="(intezmeny) in this.intezmenyek" :value="intezmeny.kod">{{ intezmeny.nev }}</option>
                </select>
            </div>
            <div class="col-sm" v-if="munkahely.felsooktatas">
                <select v-model="munkahely.karKod" class="form-control" title="Felsőoktatási kar kódja">
                    <option v-for="(kar) in this.availableKar()" :value="kar.kod">{{ kar.nev }}</option>
                </select>
            </div>
            <div class="col-sm-8" v-if="!munkahely.felsooktatas">
                <input type="text" id='nev' v-model.trim="munkahely.munkahelyNev" class="form-control" title="Beosztása" required>
            </div>
            <div></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            intezmenyek: []
        }
    },
    async created() {
        this.intezmenyek = await this.$storage.getIntezmenyekJogviszony();
    },
    props: ['munkahely', 'index', 'szemely'],
    methods: {
        deleteMunkahely() {
            const index = this.szemely.munkahelyek.indexOf(this.munkahely);
            if (index > -1)
                this.szemely.munkahelyek.splice(index, 1);
        },
        availableKar() {
            var intezmenyKod = this.munkahely.intezmenyKod;
            var intezmenyObj = this.intezmenyek.find((x) => x.kod == intezmenyKod);
            if (intezmenyObj)
                return intezmenyObj.karok;
            else
                return [];
        }
    }
}
</script>

<style scoped>
    .x-icon {
        position: absolute;
        right: 15px;
        width: 20px;
        padding: 0;
        background-color: white;
        color: black;
    }
</style>